import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components/macro';

import { Label } from '@olist/united';

export const CustomLabel = styled(Label)`
  margin-bottom: 4px;
  ${({ danger }) =>
    danger &&
    css`
      color: ${themeGet('colors.foundation.errorDefault')};
    `}
`;
